import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AfitdAvatar from './AfitdAvatar';
import cx from 'clsx';

const useStyles = (params = {}) => {
    const { props } = params;
    const { photoSize, borderSize, placeholderFontSize } = props;

    let photoWidthHeight = photoSize || 40;
    let photoFontSize = placeholderFontSize || 20; // for the "?"
    let borderPadding = borderSize || 3;

    const photoBorderWidthHeight = photoWidthHeight + 2 * borderPadding;

    return makeStyles(theme => ({
        photoBorder: {
            boxSizing: 'border-box',
            width: photoBorderWidthHeight,
            height: photoBorderWidthHeight,
            borderRadius: '50%',
            padding: borderPadding,
            background: '-webkit-linear-gradient(360deg, #f6b73c, #1D8A8B)',
            // As fallback for browsers which do not support gradient
            fallbacks: [
                { background: '#f6b73c' },
                { background: '-o-linear-gradient(360deg, #f6b73c, #1D8A8B)' },
                { background: '-moz-linear-gradient(360deg, #f6b73c, #1D8A8B)' },
                { background: 'linear-gradient(360deg, #f6b73c, #1D8A8B)' },
            ],
        },
        photo: {
            width: photoWidthHeight,
            height: photoWidthHeight,
            fontSize: photoFontSize,
        },
    }));
};

const AfitdAvatarWithRing = props => {
    const { isHidden, className, width, height, children, ...otherProps } = props;
    const classes = useStyles({ props })();

    return isHidden ? null : (
        <div className={classes.photoBorder}>
            <AfitdAvatar className={cx(classes.photo, className)} {...otherProps}>
                {children}
            </AfitdAvatar>
        </div>
    );
};

export default AfitdAvatarWithRing;
